import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL and Anon Key must be provided');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface Notice {
  id: string;
  title: string;
  content: string;
  is_pinned: boolean;
  author: string;
  views: number;
  created_at: string;
  updated_at: string;
}

export interface NoticeAttachment {
  id: string;
  notice_id: string;
  file_name: string;
  file_url: string;
  file_type: string;
  file_size: number;
  display_order: number;
  created_at: string;
}
